import { NgModule } from '@angular/core';
import { ScrollListComponent } from './scroll-list.component';

@NgModule({
    declarations: [
        ScrollListComponent
    ],
    imports: [],
    exports: [
        ScrollListComponent
    ]
})
export class NcScrollListModule { }